var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDislikeHint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86345 32.2586L1.00017 41.1473L9.80518 43.0284",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2098 36.7546C22.9198 34.7612 20.0495 33.5712 17.0313 33.3639C14.0132 33.1567 11.0108 33.9434 8.47652 35.6055L2.08184 40.8625",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4787 13.4585L28.0582 23.8285C27.0258 24.0272 25.9735 23.8887 25.1328 23.4434C24.2921 22.9981 23.7319 22.2826 23.5755 21.4541L22.7889 17.2893L15.4445 18.7029C15.069 18.7787 14.6846 18.7882 14.3181 18.7307C13.9515 18.6731 13.6115 18.5499 13.3216 18.3697C13.0317 18.1894 12.7989 17.9563 12.6393 17.6866C12.4796 17.4169 12.397 17.117 12.3971 16.8076L12.4179 7.09205C12.4179 6.57743 12.6468 6.06431 13.0622 5.64724C13.4777 5.23017 14.0518 4.93726 14.6787 4.82247L29.3155 2.0052M31.4787 13.4585L29.3155 2.0052M31.4787 13.4585L34.9432 12.7917C35.6796 12.6608 36.3542 12.3171 36.839 11.8259C37.3239 11.3348 37.5851 10.7303 37.5733 10.1273L36.1967 2.83883C35.988 2.27372 35.5247 1.80873 34.8948 1.53213C34.265 1.25552 33.5125 1.18657 32.78 1.33834L29.3155 2.0052",
    stroke: "#414141",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeHint);
export default __webpack_public_path__ + "static/media/dislike_hint.f088cf09d00e044a1be8ea4ab0476557.svg";
export { ForwardRef as ReactComponent };